import { Button } from "@/components/ui/button";
import {
	type ChangelogType,
	changelogFilterAllClass,
	changelogFilterIdleClass,
	getChangelogTypeFilterSelectedClass,
} from "@/lib/changelog-type-styles";
import { cn } from "@/lib/utils";

const types = [
	{ value: "all", label: "All" },
	{ value: "feature", label: "Feature" },
	{ value: "improvement", label: "Improvement" },
	{ value: "deprecation", label: "Deprecation" },
	{ value: "bug-fix", label: "Bug Fix" },
] as const;

export function ChangelogTypeFilter({
	selectedType,
	onSelectType,
	className = "",
}: {
	selectedType: string;
	onSelectType: (type: string) => void;
	className?: string;
}) {
	return (
		<fieldset
			className={cn(
				"m-0 min-w-0 flex flex-wrap gap-1.5 rounded-xl border border-border/60 bg-card/80 p-1.5 shadow-sm",
				className,
			)}
			aria-label="Filter by change type"
		>
			{types.map((type) => {
				const isSelected = selectedType === type.value;
				const isAll = type.value === "all";

				return (
					<Button
						key={type.value}
						variant="ghost"
						size="sm"
						onClick={() => onSelectType(type.value)}
						data-selected={isSelected ? "true" : undefined}
						className={cn(
							"h-8 cursor-pointer flex-1 rounded-lg border border-transparent px-3 sm:flex-initial",
							isAll
								? changelogFilterAllClass
								: isSelected
									? getChangelogTypeFilterSelectedClass(
											type.value as ChangelogType,
										)
									: changelogFilterIdleClass,
						)}
					>
						{type.label}
					</Button>
				);
			})}
		</fieldset>
	);
}
